/**
 * Utility function to process the label value for correct display and usage in POEditor.
 */
export function capitalizeNow(label: string | undefined): string | undefined {
  if (!label) return undefined;

  return label.toLowerCase() === 'now' ? 'Now' : label;
}
